module.exports = __webpack_public_path__ + "img/qr.aa069443.jpg";